module.exports = __webpack_public_path__ + "static/7-ae6b0c4dc3c19348c62cd954661106dc.jpeg";